"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __values = this && this.__values || function (o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var React = require("react");

var helper_1 = require("../helper");

exports.initialSpringContext = {
  addLabel: function addLabel(label) {
    return;
  },
  addLabels: function addLabels(labels) {
    return;
  },
  categories: immutable_1.Set(),
  changeCategory: function changeCategory(selectedCategory) {
    return;
  },
  currentCells: immutable_1.Set(),
  graphData: {
    nodes: new Array()
  },
  labelsByCategory: new Map(),
  removeAllCells: function removeAllCells() {
    return;
  },
  removeCells: function removeCells(cells) {
    return;
  },
  removeLabel: function removeLabel(label) {
    return;
  },
  removeLabels: function removeLabels(labels) {
    return;
  },
  selectedCategory: '',
  selectedLabels: immutable_1.Set(),
  setCells: function setCells(cells) {
    return;
  },
  toggleLabels: function toggleLabels(labels) {
    return;
  },
  update: function update(cells, selectedCategory, label) {
    return;
  }
};
exports.SpringContext = React.createContext(exports.initialSpringContext);

var SpringContextProvider =
/** @class */
function (_super) {
  __extends(SpringContextProvider, _super);

  function SpringContextProvider(props) {
    var _this = _super.call(this, props) || this;

    _this.deriveCurrentCellsFromLabels = function (selectedLabels) {
      var e_1, _a;

      var _b = _this.state,
          categories = _b.categories,
          graphData = _b.graphData,
          labelsByCategory = _b.labelsByCategory;
      var validCategories = immutable_1.Set();
      selectedLabels.forEach(function (label) {
        if (label) {
          categories.forEach(function (category) {
            if (category) {
              var labels = labelsByCategory.get(category);

              if (labels && labels.includes(label)) {
                validCategories = validCategories.add(category);
              }
            }
          });
        }
      });
      var cellIndices = immutable_1.Set();

      var _loop_1 = function _loop_1(node) {
        validCategories.forEach(function (category) {
          if (category && selectedLabels.includes(node.labelForCategory[category])) {
            cellIndices = cellIndices.add(node.number);
            return;
          }
        });
      };

      try {
        for (var _c = __values(graphData.nodes), _d = _c.next(); !_d.done; _d = _c.next()) {
          var node = _d.value;

          _loop_1(node);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally {
          if (e_1) throw e_1.error;
        }
      }

      return cellIndices;
    };

    _this.deriveValidLabelsFromCells = function (currentCells) {
      var e_2, _a, e_3, _b;

      var _c = _this.state,
          categories = _c.categories,
          graphData = _c.graphData;
      var result = immutable_1.Set();

      try {
        for (var currentCells_1 = __values(currentCells), currentCells_1_1 = currentCells_1.next(); !currentCells_1_1.done; currentCells_1_1 = currentCells_1.next()) {
          var cellIndex = currentCells_1_1.value;

          try {
            for (var _d = __values(categories.toArray()), _e = _d.next(); !_e.done; _e = _d.next()) {
              var category = _e.value;
              result = result.add(graphData.nodes[cellIndex].labelForCategory[category]);
            }
          } catch (e_3_1) {
            e_3 = {
              error: e_3_1
            };
          } finally {
            try {
              if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
            } finally {
              if (e_3) throw e_3.error;
            }
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (currentCells_1_1 && !currentCells_1_1.done && (_a = currentCells_1.return)) _a.call(currentCells_1);
        } finally {
          if (e_2) throw e_2.error;
        }
      }

      return result;
    };

    _this.onAddLabel = function (label) {
      var selectedLabels = _this.state.selectedLabels;

      if (!selectedLabels.includes(label)) {
        _this.setState({
          selectedLabels: selectedLabels.add(label)
        });
      }
    };

    _this.onAddLabels = function (labels) {
      var e_4, _a;

      var selectedLabels = _this.state.selectedLabels;

      try {
        for (var labels_1 = __values(labels), labels_1_1 = labels_1.next(); !labels_1_1.done; labels_1_1 = labels_1.next()) {
          var label = labels_1_1.value;

          if (!selectedLabels.includes(label)) {
            selectedLabels = selectedLabels.add(label);
          }
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (labels_1_1 && !labels_1_1.done && (_a = labels_1.return)) _a.call(labels_1);
        } finally {
          if (e_4) throw e_4.error;
        }
      }

      _this.setState({
        selectedLabels: selectedLabels
      });
    };

    _this.onChangeCategory = function (selectedCategory) {
      _this.setState({
        selectedCategory: selectedCategory
      });
    };

    _this.onRemoveAllCells = function () {
      _this.setState({
        currentCells: immutable_1.Set()
      });
    };

    _this.onRemoveCells = function (cellsToRemove) {
      var currentCells = _this.state.currentCells;

      _this.setState({
        currentCells: immutable_1.Set(currentCells.filter(function (cell) {
          return cell !== undefined && !cellsToRemove.includes(cell);
        }))
      });
    };

    _this.onRemoveLabel = function (label) {
      var selectedLabels = _this.state.selectedLabels;

      _this.setState({
        selectedLabels: selectedLabels.remove(label)
      });
    };

    _this.onRemoveLabels = function (labels) {
      var e_5, _a;

      var selectedLabels = _this.state.selectedLabels;

      try {
        for (var labels_2 = __values(labels), labels_2_1 = labels_2.next(); !labels_2_1.done; labels_2_1 = labels_2.next()) {
          var label = labels_2_1.value;
          selectedLabels = selectedLabels.remove(label);
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (labels_2_1 && !labels_2_1.done && (_a = labels_2.return)) _a.call(labels_2);
        } finally {
          if (e_5) throw e_5.error;
        }
      }

      _this.setState({
        selectedLabels: selectedLabels
      });
    };

    _this.onSetCells = function (cells) {
      _this.setState({
        currentCells: immutable_1.Set(cells)
      });
    };

    _this.onToggleLabels = function (labels) {
      var e_6, _a;

      var selectedLabels = _this.state.selectedLabels;

      try {
        for (var labels_3 = __values(labels), labels_3_1 = labels_3.next(); !labels_3_1.done; labels_3_1 = labels_3.next()) {
          var label = labels_3_1.value;
          selectedLabels = selectedLabels.includes(label) ? selectedLabels.remove(label) : selectedLabels.add(label);
        }
      } catch (e_6_1) {
        e_6 = {
          error: e_6_1
        };
      } finally {
        try {
          if (labels_3_1 && !labels_3_1.done && (_a = labels_3.return)) _a.call(labels_3);
        } finally {
          if (e_6) throw e_6.error;
        }
      }

      _this.setState({
        currentCells: _this.deriveCurrentCellsFromLabels(selectedLabels),
        selectedLabels: selectedLabels
      });
    };

    _this.onUpdate = function (currentCells, selectedCategory) {
      _this.setState({
        currentCells: immutable_1.Set(currentCells),
        selectedCategory: selectedCategory ? selectedCategory : _this.state.selectedCategory,
        selectedLabels: _this.deriveValidLabelsFromCells(currentCells)
      });
    };

    _this.state = __assign({}, exports.initialSpringContext, {
      addLabel: _this.onAddLabel,
      addLabels: _this.onAddLabels,
      changeCategory: _this.onChangeCategory,
      removeAllCells: _this.onRemoveAllCells,
      removeCells: _this.onRemoveCells,
      removeLabel: _this.onRemoveLabel,
      removeLabels: _this.onRemoveLabels,
      setCells: _this.onSetCells,
      toggleLabels: _this.onToggleLabels,
      update: _this.onUpdate
    });
    return _this;
  }

  SpringContextProvider.prototype.componentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.setupData()];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  SpringContextProvider.prototype.componentDidUpdate = function (prevProps) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(this.props.datasetLocation !== prevProps.datasetLocation)) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this.setupData()];

          case 1:
            _a.sent();

            _a.label = 2;

          case 2:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  SpringContextProvider.prototype.render = function () {
    return React.createElement(exports.SpringContext.Provider, {
      value: this.state
    }, this.props.children);
  };

  SpringContextProvider.prototype.setupData = function () {
    return __awaiter(this, void 0, void 0, function () {
      var graphData_1, categories, labelsByCategory_1, e_7;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , helper_1.fetchSpringData("assets/datasets/" + this.props.datasetLocation)];

          case 1:
            graphData_1 = _a.sent();
            categories = immutable_1.Set(graphData_1.nodes.length >= 1 ? Object.keys(graphData_1.nodes[0].labelForCategory) : []);
            labelsByCategory_1 = new Map();
            categories.forEach(function (category) {
              if (category) {
                var labels = immutable_1.Set(Array.from(graphData_1.nodes.map(function (node) {
                  return node.labelForCategory[category];
                })));
                labelsByCategory_1.set(category, labels);
              }
            });
            this.setState({
              categories: categories,
              graphData: graphData_1,
              labelsByCategory: labelsByCategory_1
            });
            return [3
            /*break*/
            , 3];

          case 2:
            e_7 = _a.sent();
            console.log(e_7);
            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return SpringContextProvider;
}(React.Component);

exports.SpringContextProvider = SpringContextProvider;